module.exports = __webpack_public_path__ + "static/media/back-new-9.68ff6dcd.jpg";